/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomCssPresetDto } from '../../models/custom-css-preset-dto';

export interface CustomCssControllerFindLatestByProduct$Params {
  storeId: string;
  product: string;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function customCssControllerFindLatestByProduct(http: HttpClient, rootUrl: string, params: CustomCssControllerFindLatestByProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomCssPresetDto>> {
  const rb = new RequestBuilder(rootUrl, customCssControllerFindLatestByProduct.PATH, 'get');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.path('product', params.product, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomCssPresetDto>;
    })
  );
}

customCssControllerFindLatestByProduct.PATH = '/api/v1/stores/{storeId}/custom-css/{product}';
